export default __webpack_public_path__ + "imgs/ae7427403086bbc93db3cd7ec86a3a37.jpg";